module.exports = {"230111001":"兰河街道","230111002":"呼兰街道","230111003":"建设路街道","230111004":"利民街道","230111005":"学院路街道","230111006":"腰卜街道","230111007":"康金街道","230111008":"双井街道","230111009":"长岭街道","230111010":"沈家街道","230111105":"二八镇","230111106":"石人镇","230111107":"白奎镇","230111109":"方台镇","230111110":"莲花镇","230111111":"大用镇","230111114":"利业镇","230111201":"杨林乡","230111203":"许卜乡","230111205":"孟家乡","230111579":"呼兰农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230111.json
// module id = 621
// module chunks = 0